export default __webpack_public_path__ + "static/media/calendar.5d87fdad.svg";